import { makeStyles } from '@mui/styles';
import { neutral6 } from 'apollo-react/colors';
import Tooltip from 'apollo-react/components/Tooltip';
import qs from 'query-string';
import React from 'react';
import { Link } from 'react-router-dom';

import { DOCUMENT_COMPARE } from '../../constants/Urls';
import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getWorkflowInfo } from '../../form-designer/selectors/common.selectors';

const useStyles = makeStyles({
  link: {
    color: '#06C',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  disabledLink: {
    fontSize: 14,
    color: neutral6,
    fontWeight: 400,
    lineHeight: 1.5,
  },
});

const CompareRevisionsLinkCell = ({ row }) => {
  const classes = useStyles();
  const translateString = useTranslation();
  const { itmId } = useFormSelector(getWorkflowInfo);

  return row.DOC_ID ? (
    <Link
      className={classes.link}
      to={{
        pathname: DOCUMENT_COMPARE,
        search: qs.stringify({
          compareDocId: row.DOC_ID,
          docId: itmId,
          documentType: 'PRIMARY',
          isForDownload: false,
        }),
      }}
      target="_blank"
    >
      {translateString('Compare')}
    </Link>
  ) : (
    <Tooltip title={translateString('Cannot compare, document not found.')}>
      <span className={classes.disabledLink}>{translateString('Compare')}</span>
    </Tooltip>
  );
};

export default CompareRevisionsLinkCell;
